module.exports = __webpack_public_path__ + "static/img/shenru.c46fd01c.png";